// ./01 - PROJETOS DEV/meu-controle-de-estoque/src/components/modals/EditExpensePaymentModal.jsx
import React, { useState, useEffect } from 'react';

const EditExpensePaymentModal = ({ isOpen, onClose, onSave, paymentItem }) => {
    const [amount, setAmount] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('Pix');
    const [paymentDate, setPaymentDate] = useState('');
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        if (isOpen && paymentItem) {
            setAmount(paymentItem.amount || '');
            setPaymentMethod(paymentItem.method || 'Pix');
            setPaymentDate(paymentItem.date ? new Date(paymentItem.date).toISOString().split('T')[0] : '');
        }
    }, [isOpen, paymentItem]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const paymentAmount = parseFloat(amount);
        
        if (isNaN(paymentAmount) || paymentAmount <= 0) {
            alert('Por favor, insira um valor válido.');
            return;
        }

        if (isSaving) return;
        setIsSaving(true);
        
        try {
            const dateOfPayment = new Date(`${paymentDate}T12:00:00`);
            // O sistema automaticamente recálcula o saldo das parcelas lá no usePurchases!
            await onSave(paymentItem.purchaseId, paymentItem.id, {
                amount: paymentAmount,
                method: paymentMethod,
                date: dateOfPayment
            });
            onClose();
        } catch (error) {
            console.error("Erro ao atualizar pagamento:", error);
            alert("Erro ao salvar alterações.");
        } finally {
            setIsSaving(false);
        }
    };

    if (!isOpen || !paymentItem) return null;

    return (
        <div className="modal-overlay z-50 flex items-center justify-center fixed inset-0 bg-black bg-opacity-50">
            <div className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-md m-4">
                <h2 className="text-2xl font-bold text-gray-800 mb-2">Editar Pagamento</h2>
                <p className="text-gray-600 mb-6 text-sm">Ajustar os dados deste pagamento: <br/> <strong>{paymentItem.description}</strong></p>
                
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="form-label text-sm font-semibold text-gray-700">Data do Pagamento</label>
                        <input type="date" value={paymentDate} onChange={e => setPaymentDate(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg" required />
                    </div>
                    <div>
                        <label className="form-label text-sm font-semibold text-gray-700">Forma de Pagamento</label>
                        <select value={paymentMethod} onChange={e => setPaymentMethod(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg">
                            <option value="Pix">Pix</option>
                            <option value="Cartão de Crédito">Cartão de Crédito</option>
                            <option value="Boleto">Boleto</option>
                            <option value="Dinheiro">Dinheiro</option>
                            <option value="Transferência">Transferência</option>
                        </select>
                    </div>
                    <div>
                        <label className="form-label text-sm font-semibold text-gray-700">Valor Pago (R$)</label>
                        <input value={amount} onChange={e => setAmount(e.target.value)} type="number" step="0.01" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-[#D7BFBD] focus:border-[#D7BFBD]" required />
                    </div>
                    <div className="flex flex-col-reverse sm:flex-row justify-end gap-4 pt-4 border-t mt-4">
                        <button type="button" onClick={onClose} className="py-2 px-6 bg-gray-200 rounded-lg font-semibold text-gray-800 hover:bg-gray-300">Cancelar</button>
                        <button type="submit" disabled={isSaving} className="custom-button py-2 px-6 rounded-lg font-semibold">{isSaving ? 'Salvando...' : 'Salvar Alterações'}</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EditExpensePaymentModal;